module.exports = __webpack_public_path__ + "img/breath_red.759b9aca.png";